import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';
import { Icon } from '../Icon';
import { linkBase } from '../Link';

interface ILinkButton {
  $size?: 'xsmall' | 'small';
  $tone?: 'main' | 'alt' | 'error';
  $underline?: boolean;
  $hasContent?: boolean;
  $hoverGhost?: boolean;
  $displayBlock?: boolean;
  $largeGap?: boolean;
  $noWrap?: boolean;
  $maxContent?: boolean;
  $disabled?: boolean;
}

export const LinkButton = styled.span.attrs(() => ({
  role: 'button',
  tabIndex: 0,
}))<ILinkButton>`
  ${linkBase}

  font-size: var(--link-button-font-size, 1em);
  user-select: none;

  ${Icon} {
    font-size: var(--link-button-icon-size, ${(props) => props.theme.font.size.xxlarge});
  }

  ${({ $size }) =>
    $size === 'small'
      ? css`
          --link-button-font-size: ${(props) => props.theme.font.size.small};
          --link-button-icon-size: ${(props) => props.theme.font.size.xlarge};
        `
      : $size === 'xsmall'
        ? css`
            --link-button-font-size: ${(props) => props.theme.font.size.xsmall};
            --link-button-icon-size: ${(props) => props.theme.font.size.large};
          `
        : undefined}

  ${({ $tone }) =>
    $tone === 'main'
      ? css`
          color: var(--c-text-main);
        `
      : $tone === 'alt'
        ? css`
            color: var(--c-text-muted);
          `
        : $tone === 'error'
          ? css`
              color: var(--c-input-error-text);
            `
          : undefined}

  ${({ $hasContent }) =>
    $hasContent &&
    css`
      display: inline-flex;
      align-items: center;
    `}

  ${({ $underline }) =>
    $underline &&
    css`
      text-decoration: underline;
    `}

  ${({ $largeGap }) =>
    $largeGap &&
    css`
      gap: ${size(1.5)};
    `}

  ${({ $noWrap }) =>
    $noWrap &&
    css`
      white-space: nowrap;
    `}

  ${({ $displayBlock }) =>
    $displayBlock &&
    css`
      display: flex;
    `}

  ${({ $maxContent }) =>
    $maxContent &&
    css`
      max-width: max-content;
    `}

  ${({ $hoverGhost }) =>
    $hoverGhost &&
    css`
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    `}

    ${({ $disabled }) =>
      $disabled &&
      css`
      cursor: not-allowed;
      opacity: 0.38;
    `}
`;

export const LinkButtonContent = styled.span`
  display: block;

  & + & {
    margin-left: ${size(1)};
  }
`;
